import _asyncToGenerator from "/app/web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "/app/web/node_modules/@babel/runtime/regenerator";
import { message, Tooltip } from 'antd';
import { Colors, TaskStateColorDark } from 'core/interfaces/variables.types';
import { TaskState } from 'core/modules/tasks/task.interface';
import { taskCanChangeState, taskPossibleStates } from 'core/modules/tasks/task.service';
import { getTaskStore } from 'core/modules/tasks/task.store';
import { useTranslation } from 'react-i18next';
import styled, { css } from 'styled-components';
import { TaskStateIcon } from '../../types/task.types';
import { classes } from '../../utils/classes';
import { TaskProgressConfirmPopopver } from './Progress/ConfirmPopover';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var TaskProgress = function TaskProgress(_ref) {
  var task = _ref.task,
      isExpanded = _ref.isExpanded,
      onStateChanged = _ref.onStateChanged;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _getTaskStore = getTaskStore(),
      updateTaskState = _getTaskStore.updateTaskState;

  function onUpdateTaskState(_x, _x2, _x3, _x4) {
    return _onUpdateTaskState.apply(this, arguments);
  }

  function _onUpdateTaskState() {
    _onUpdateTaskState = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(state, deadline, assignee, content) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return updateTaskState(task.id, state, deadline, assignee, content);

            case 3:
              onStateChanged();
              _context.next = 9;
              break;

            case 6:
              _context.prev = 6;
              _context.t0 = _context["catch"](0);
              message.error(t('unknownError'));

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 6]]);
    }));
    return _onUpdateTaskState.apply(this, arguments);
  }

  return /*#__PURE__*/_jsx(Container, {
    children: taskPossibleStates(task).map(function (state) {
      return /*#__PURE__*/_jsx("div", {
        className: "step state-".concat(state, " current-").concat(task.state, " ").concat(classes({
          available: taskCanChangeState(task, state),
          unavailable: !taskCanChangeState(task, state),
          current: task.state === state
        })),
        children: /*#__PURE__*/_jsx("div", {
          className: "content",
          children: /*#__PURE__*/_jsxs(TaskProgressConfirmPopopver, {
            task: task,
            state: state,
            isDisabled: !taskCanChangeState(task, state),
            onConfirmed: function onConfirmed(deadline, assignee, content) {
              return onUpdateTaskState(state, deadline, assignee, content);
            },
            children: [/*#__PURE__*/_jsx("div", {
              className: "icon",
              children: /*#__PURE__*/_jsx(Tooltip, {
                open: isExpanded ? false : undefined,
                title: t("tasks.state.".concat(state)),
                children: TaskStateIcon[state]
              })
            }), isExpanded && /*#__PURE__*/_jsx("div", {
              className: "name",
              children: t("tasks.state.".concat(state))
            })]
          })
        })
      }, state);
    })
  });
}; // Styles

var Container = styled.div.withConfig({
  displayName: "Progress__Container",
  componentId: "sc-v02yox-0"
})(["display:flex;width:calc(100% + 48px);align-items:flex-start;justify-content:space-evenly;background:#fafafa;margin:-24px -24px 0px -24px;padding:20px 20px;border-bottom:1px solid #f0f0f0;.step{display:flex;flex-direction:column;align-items:center;justify-content:space-between;width:150px;text-align:center;height:100%;opacity:1;cursor:pointer;position:relative;.content{transition:all 0.4s ease-in-out;.icon{font-size:24px;}.name{font-size:12px;margin-top:6px;max-width:80px;}}", " &.unavailable{.content{opacity:0.25;}cursor:default;}&.current,&.available:hover,&.available:active,&.available:focus{.content{opacity:1;}.anticon,.name{color:", ";}&::before,&::after{background-color:", " !important;}}.anticon{position:relative;&::after{content:'';z-index:-1;position:absolute;top:-9px;left:-9px;height:42px;width:42px;transform-origin:50% 50%;transform:scale3d(0,0,0);background:transparent;border-radius:50%;transition:all 0.4s ease-in-out;}}&.current .anticon{color:white !important;z-index:1000;position:relative;&::after{background:", ";transform:scale3d(1,1,1);}}&::before{content:'';position:absolute;background-color:", ";height:1px;left:0px;right:calc(50% + 24px);top:16px;}&::after{content:'';position:absolute;background-color:", ";height:1px;left:calc(50% + 24px);right:0px;top:16px;}}"], Object.values(TaskState).map(function (state) {
  return css(["&.state-", "{.anticon{color:", ";}.name{color:", ";}&::before,&::after{background-color:", " !important;}}"], state, TaskStateColorDark[state], TaskStateColorDark[state], TaskStateColorDark[state]);
}), Colors.primary, Colors.primary, Colors.primary, Colors.primary, Colors.primary);